//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { Auth } from "aws-amplify";
export class BackendClientBase {
  constructor() {}

  private getAuthHeader = async () => {
    const user = await Auth.currentSession();
    return {
      Authorization: `Bearer ${user.getAccessToken().getJwtToken()}`,
    };
  };

  protected transformOptions = async (
    options: RequestInit
  ): Promise<RequestInit> => {
    const auth = await this.getAuthHeader();
    options.headers = {
      ...options.headers,
      ...auth,
    };
    return options;
  };
}

export interface IBackendClientGenerated {

    /**
     * @return Success
     */
    addSubmissions(body: AddSubmisisonsModel): Promise<SubmissionViewModel[]>;

    /**
     * @return Success
     */
    getRegions(): Promise<AvailableRegionsViewModel[]>;

    /**
     * @return Success
     */
    removeSubmissions(body: string[]): Promise<SubmissionViewModel[]>;

    /**
     * @return Success
     */
    getRelatedSubmissions(submissionId: string): Promise<RelatedSubmissionsModel>;

    /**
     * @return Success
     */
    getSubmissions(searchString: string, field: SearchField): Promise<SubmissionViewModel[]>;
}

export class BackendClientGenerated extends BackendClientBase implements IBackendClientGenerated {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    addSubmissions(body: AddSubmisisonsModel): Promise<SubmissionViewModel[]> {
        let url_ = this.baseUrl + "/api/Submissions/AddSubmissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddSubmissions(_response);
        });
    }

    protected processAddSubmissions(response: Response): Promise<SubmissionViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubmissionViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmissionViewModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getRegions(): Promise<AvailableRegionsViewModel[]> {
        let url_ = this.baseUrl + "/api/Submissions/GetRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRegions(_response);
        });
    }

    protected processGetRegions(response: Response): Promise<AvailableRegionsViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AvailableRegionsViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableRegionsViewModel[]>(null as any);
    }

    /**
     * @return Success
     */
    removeSubmissions(body: string[]): Promise<SubmissionViewModel[]> {
        let url_ = this.baseUrl + "/api/Submissions/RemoveSubmissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveSubmissions(_response);
        });
    }

    protected processRemoveSubmissions(response: Response): Promise<SubmissionViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubmissionViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmissionViewModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getRelatedSubmissions(submissionId: string): Promise<RelatedSubmissionsModel> {
        let url_ = this.baseUrl + "/api/Submissions/GetRelatedSubmissions?";
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined and cannot be null.");
        else
            url_ += "submissionId=" + encodeURIComponent("" + submissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRelatedSubmissions(_response);
        });
    }

    protected processGetRelatedSubmissions(response: Response): Promise<RelatedSubmissionsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RelatedSubmissionsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelatedSubmissionsModel>(null as any);
    }

    /**
     * @return Success
     */
    getSubmissions(searchString: string, field: SearchField): Promise<SubmissionViewModel[]> {
        let url_ = this.baseUrl + "/api/Submissions/GetSubmissions?";
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined and cannot be null.");
        else
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (field === undefined || field === null)
            throw new Error("The parameter 'field' must be defined and cannot be null.");
        else
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubmissions(_response);
        });
    }

    protected processGetSubmissions(response: Response): Promise<SubmissionViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubmissionViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmissionViewModel[]>(null as any);
    }
}

export interface AddSubmisisonsModel {
    submissionIds: string[];
    regionId: number;
    comment?: string | undefined;
    isManual: boolean;
}

export interface AvailableRegionsViewModel {
    regionCode: string;
    regionId: number;
}

export interface RelatedSubmissionsModel {
    submissionIds: string[];
    regionId: number;
}

export enum SearchField {
    CustomerName = "CustomerName",
    LicenseName = "LicenseName",
    SubmissionId = "SubmissionId",
}

export interface SubmissionViewModel {
    submissionId: string;
    customerName?: string | undefined;
    excludedAt?: Date | undefined;
    submissionReceivedAt?: Date | undefined;
    isExcluded?: boolean;
    examId?: number | undefined;
    licenseName?: string | undefined;
    excludedBy?: string | undefined;
    regionId: number;
    readonly isUnmatched: boolean;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}